import { render, staticRenderFns } from "./dfxViewer.vue?vue&type=template&id=11788bb4&scoped=true"
import script from "./dfxViewer.vue?vue&type=script&lang=js"
export * from "./dfxViewer.vue?vue&type=script&lang=js"
import style0 from "./dfxViewer.vue?vue&type=style&index=0&id=11788bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11788bb4",
  null
  
)

export default component.exports